import { memo, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { LoadingButton } from "@mui/lab";
import { Box, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { t } from "i18next";

import { loginPartner } from "src/pages/partner/model/partnerAsyncActions";

import { authSchema } from "./schemas";

const initialValues = {
  email: "",
  password: "",
};

const paperStyle = {
  padding: 20,
  minWidth: "35%",
  margin: "20px auto",
};

const AuthPartner = (props) => {
  const { isLoading, errors } = props;

  const [validation, setValidation] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: authSchema,
    validateOnChange: validation,
    validateOnBlur: validation,
    onSubmit: async (values) => {
      await dispatch(loginPartner(values));
    },
  });

  const handleFormSubmit = useCallback((event) => {
    setValidation(true);
    formik.handleSubmit(event);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (errors?.general) {
      formik.setErrors({ general: errors.general });
      return;
    }

    if (errors) {
      Object.entries(errors).forEach(([field, error]) => {
        formik.setFieldError(field, error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <Paper elevation={7} style={paperStyle}>
      <Typography align="center" variant="h5">
        {t("sign_in")}
      </Typography>
      <form onSubmit={handleFormSubmit}>
        <Box mt={2}>
          <TextField
            error={Boolean(formik.errors.email || formik.errors.general)}
            fullWidth
            helperText={t(formik.errors.email)}
            label={t("email")}
            name="email"
            onChange={formik.handleChange}
            required
            value={formik.values.email}
          />
        </Box>
        <Box mt={2}>
          <TextField
            error={Boolean(formik.errors.password || formik.errors.general)}
            fullWidth
            helperText={t(formik.errors.password || formik.errors.general)}
            label={t("password")}
            name="password"
            onChange={formik.handleChange}
            required
            type="password"
            value={formik.values.password}
          />
        </Box>
        <Box mt={2}>
          <LoadingButton fullWidth loading={isLoading} loadingPosition="center" size="large" type="submit" variant="contained">
            {t("sign_in")}
          </LoadingButton>
        </Box>
      </form>
    </Paper>
  );
};

export default memo(AuthPartner);
